// extracted by mini-css-extract-plugin
var _1 = "Select-moduleerror__iI4_J";
var _2 = "Select-moduleselect__dfblC";
export { _1 as "error", _2 as "select" }
